import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useClasificationService from '../../../app/services/hooks/useClasificationService';

interface Props {
    clasificationId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ClasificationSwitchChange = ({ clasificationId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeClasification, fetchingActiveClasfication } = useClasificationService();

    const active = (value: boolean) => {
        setChecked(value);

        activeClasification(clasificationId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={clasificationId} callback={active} />;
};

export default ClasificationSwitchChange;
